/* EcomX 16 Oct 2026 - Mix & Match offer: "save more", never "spend more".
   - Loads BEFORE ssbb-bundle.js (not deferred) so it can drop the Any 10 tier.
   - No minimum: any number of packs can check out. Customer always gets the best price:
     groups of 8 at ₹999 / 4 at ₹699, the rest at normal price.
   - Checkout adds the hidden "Mix and Match Pack" bundle lines (fixed price) + any extra
     packs at normal price, so Shiprocket always shows the same price as the page. */
(function () {
  var BUNDLE_PRODUCT_ID = 16074067116401;
  var TIERS = [
    { qty: 8, price: 999, label: "Any 8 @ ₹999", variant: 67761564451185 },
    { qty: 4, price: 699, label: "Any 4 @ ₹699", variant: 67761564418417 }
  ];
  var CAP = 8;
  // Fallback prices for offer items (Pack of 1 agarbatti = 189, dhoop = 199); refreshed from /products.json.
  var PRICE = {
    64576576356721: 189, 64576576979313: 189, 64576576029041: 189, 64576576717169: 189, 64576576192881: 189, 64576575865201: 189,
    64576575701361: 199, 64576575832433: 199, 64576575537521: 199, 64576575734129: 199, 64576575635825: 199, 64576575504753: 199
  };

  // 1) Keep only the 4 and 8 tiers (Any 10 at ₹1,999 cost more than buying packs singly).
  try {
    var cfg;
    Object.defineProperty(window, "SS_CONFIG", {
      configurable: true,
      get: function () { return cfg; },
      set: function (v) {
        if (v && v.tiers) v.tiers = v.tiers.filter(function (t) { return t.qty === 4 || t.qty === 8; });
        cfg = v;
      }
    });
  } catch (e) {}

  var inr = function (n) { return "₹" + Math.round(Number(n)).toLocaleString("en-IN"); };
  var $ = function (s) { return document.querySelector(s); };

  function readUnits() {
    var out = [], slots = document.querySelectorAll("#ssbb-thumbs [data-rm]");
    for (var i = 0; i < slots.length; i++) {
      var id = +slots[i].getAttribute("data-rm");
      var slot = slots[i].closest(".ssbb-slot");
      var ph = slot && slot.querySelector(".ssbb-ph");
      out.push({ id: id, price: PRICE[id] || 189, name: (ph && ph.textContent.trim()) || "Pack" });
    }
    return out;
  }

  function plan(units) {
    var u = units.slice().sort(function (a, b) { return b.price - a.price; });
    var groups = [], i = 0, pay = 0;
    for (;;) {
      var picked = null;
      for (var j = 0; j < TIERS.length && !picked; j++) {
        var t = TIERS[j];
        if (u.length - i < t.qty) continue;
        var s = 0;
        for (var m = i; m < i + t.qty; m++) s += u[m].price;
        if (t.price < s) picked = t;
      }
      if (!picked) break;
      groups.push({ tier: picked, units: u.slice(i, i + picked.qty) });
      pay += picked.price; i += picked.qty;
    }
    var extras = u.slice(i);
    extras.forEach(function (x) { pay += x.price; });
    return { pay: pay, groups: groups, extras: extras };
  }

  function sum(units) { var s = 0; units.forEach(function (x) { s += x.price; }); return s; }

  function nextSaving(units, save) {
    var p0 = 189;
    for (var k = 1; units.length + k <= CAP; k++) {
      var more = units.slice();
      for (var z = 0; z < k; z++) more.push({ id: 0, price: p0, name: "" });
      var s2 = sum(more) - plan(more).pay;
      if (s2 > save) return { k: k, extra: s2 - save };
    }
    return null;
  }

  var last = { msg: null, cta: null, dis: null, mini: null };
  function render() {
    var msg = $("#ssbb-msg"), cta = $("#ssbb-offer-cta"), mini = $("#ssbb-mini");
    if (!msg || !cta || !mini) return;
    var u = readUnits(), n = u.length, p = plan(u), save = sum(u) - p.pay, nx = nextSaving(u, save);
    var packs = n + " pack" + (n === 1 ? "" : "s");
    if (!n) {
      msg.innerHTML = "Mix any fragrances · <b>4 for ₹699</b> · <b>8 for ₹999</b><small>No minimum — pick as many as you like, we apply the best price.</small>";
      cta.disabled = true; cta.textContent = "Pick your packs";
      mini.hidden = true; mini.innerHTML = "";
    } else {
      msg.innerHTML = (save > 0 ? "<b>You save " + inr(save) + "</b> on " + packs : "<b>" + packs + " · " + inr(p.pay) + "</b>") +
        "<small>" + (nx ? "Optional: add " + nx.k + " more to save " + inr(nx.extra) + (save > 0 ? " more" : "") : "Best price unlocked ✓") + "</small>";
      cta.disabled = false; cta.textContent = "Checkout · " + inr(p.pay);
      if (nx) { mini.innerHTML = '<button type="button" data-fillto="' + (n + nx.k) + '">✦ Save ' + inr(nx.extra) + " more with a mix</button>"; mini.hidden = false; }
      else { mini.hidden = true; mini.innerHTML = ""; }
    }
    last = { msg: msg.innerHTML, cta: cta.textContent, dis: cta.disabled, mini: mini.innerHTML };
  }

  function patchCopy() {
    var how = $("#ssbb-how");
    if (how && /lock the offer/.test(how.innerHTML)) {
      how.innerHTML = how.innerHTML
        .replace(/Pick any \d+\+/, "Pick any packs")
        .replace("Repeats allowed.", "Repeats allowed. No minimum.")
        .replace("Unlock a price", "Save more as you add")
        .replace(/Hit [\d \/]+ to lock the offer\./, "4 for ₹699 · 8 for ₹999 — extra packs at normal price.");
    }
    var faq = $("#ssbb-faq");
    if (faq && /applied automatically at checkout\.<\/p>/.test(faq.innerHTML) && !/No minimum/.test(faq.innerHTML)) {
      faq.innerHTML = faq.innerHTML.replace("applied automatically at checkout.</p>", "applied automatically at checkout. No minimum — buy any number of packs and we always apply the best price.</p>");
    }
  }

  var queued = false;
  function schedule() {
    if (queued) return; queued = true;
    setTimeout(function () {
      queued = false;
      var msg = $("#ssbb-msg"), cta = $("#ssbb-offer-cta"), mini = $("#ssbb-mini");
      if (msg && cta && mini && (msg.innerHTML !== last.msg || cta.textContent !== last.cta || cta.disabled !== last.dis || mini.innerHTML !== last.mini)) render();
      patchCopy();
    }, 0);
  }

  function post(url, body) {
    return fetch(url, {
      method: "POST", credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }

  function listOf(units) {
    var c = {}, order = [];
    units.forEach(function (x) { if (!c[x.name]) { c[x.name] = 0; order.push(x.name); } c[x.name]++; });
    return order.map(function (nm) { return c[nm] + " × " + nm; }).join(", ");
  }

  function openCheckout(btn, oldText) {
    var f = window.shiprocketCheckoutBuyCartHandler;
    if (typeof f === "function") {
      try {
        f({ preventDefault: function () {}, stopPropagation: function () {}, stopImmediatePropagation: function () {}, target: btn, currentTarget: btn, type: "click" });
        btn.disabled = false; btn.textContent = oldText;
        return;
      } catch (e) {}
    }
    location.href = "/checkout";
  }

  document.addEventListener("click", function (e) {
    var btn = e.target && e.target.closest ? e.target.closest("#ssbb-offer-cta") : null;
    if (!btn) return;
    e.preventDefault(); e.stopImmediatePropagation();
    if (btn.disabled) return;
    var units = readUnits();
    if (!units.length) return;
    var p = plan(units);
    var errEl = $("#ssbb-offer-err");
    if (errEl) errEl.hidden = true;
    var oldText = btn.textContent;
    btn.disabled = true; btn.textContent = "Taking you to checkout…";

    var items = p.groups.map(function (g) {
      return { id: g.tier.variant, quantity: 1, properties: { Bundle: g.tier.label, Fragrances: listOf(g.units), _picks: g.units.map(function (x) { return x.id; }).join(",") } };
    });
    var ex = {};
    p.extras.forEach(function (x) { ex[x.id] = (ex[x.id] || 0) + 1; });
    Object.keys(ex).forEach(function (id) { items.push({ id: +id, quantity: ex[id], properties: { _ssoffer: "1" } }); });

    fetch("/cart.js", { credentials: "same-origin", headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var updates = {}, any = false;
        (cart.items || []).forEach(function (it) {
          var pr = it.properties || {};
          if (it.product_id === BUNDLE_PRODUCT_ID || pr.Bundle || pr._ssoffer) { updates[it.key] = 0; any = true; }
        });
        return any ? post("/cart/update.js", { updates: updates }) : null;
      })
      .then(function () { return post("/cart/add.js", { items: items }); })
      .then(function () { openCheckout(btn, oldText); })
      .catch(function (j) {
        if (errEl) { errEl.textContent = (j && (j.description || j.message)) || "Something went wrong. Please try again."; errEl.hidden = false; }
        btn.disabled = false; btn.textContent = oldText;
      });
  }, true);

  function start() {
    var app = document.getElementById("ssbb-app");
    if (!app) return;
    new MutationObserver(schedule).observe(app, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ["disabled", "hidden"] });
    schedule();
    fetch("/products.json?limit=250", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        (d.products || []).forEach(function (pr) { pr.variants.forEach(function (v) { if (PRICE[v.id]) PRICE[v.id] = +v.price; }); });
        last.msg = null; schedule();
      }).catch(function () {});
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start); else start();
})();
